import { DATE_FORMAT } from "@/shared/common/constants";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

const TIMEZONE = "Asia/Yerevan";

export const formatDate = (date?: Date | string, format?: string) => {
  if (!date) return "";

  const day = typeof date === "string" ? dayjs(date) : dayjs(date);
  return day.tz(TIMEZONE).format(format || DATE_FORMAT.DEFAULT);
};

export const daysApart = (a: Date, b: Date) => {
  const startA = dayjs(a).startOf("day");
  const startB = dayjs(b).startOf("day");
  return Math.abs(startA.diff(startB, "day"));
};

export const isBeforeDate = (dateToCheck: string, referenceDate: string) => {
  const check = dayjs.tz(dateToCheck, DATE_FORMAT.DEFAULT, TIMEZONE);
  const reference = dayjs.tz(referenceDate, DATE_FORMAT.DEFAULT, TIMEZONE);
  return check.isBefore(reference);
};

export const clampToCurrentDate = (date?: string) => {
  if (!date) return "";
  const today = dayjs.tz(undefined, TIMEZONE).startOf("day");
  const parsed = dayjs.tz(date, DATE_FORMAT.YYYY_MM_DD, TIMEZONE);
  return new Date(parsed.isBefore(today) ? today.format(DATE_FORMAT.YYYY_MM_DD) : date);
};
